module.exports = __webpack_public_path__ + "img/ajuan.f296439.png";